
import {filter} from 'rxjs/operators';
import {Component, DestroyRef, inject} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';


@Component({
    selector: 'app-breadcrumbs',
    template: `
  @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
    @if (breadcrumb.label.title||breadcrumb.label.title&&last) {
      <li class="breadcrumb-item"
        [ngClass]="{active: last}">
        @if (!last) {
          <a [routerLink]="breadcrumb.url">{{breadcrumb.label.title}}</a>
        }
        @if (last) {
          <span [routerLink]="breadcrumb.url">{{breadcrumb.label.title}}</span>
        }
      </li>
    }
  }`,
    standalone: false
})
export class AppBreadcrumbsComponent {
  breadcrumbs: Array<{ label: { title: string }; url: string }>;
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((event) => {

      this.breadcrumbs = [];
      let currentRoute = this.route.root,
      url = '';

      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        // tslint:disable-next-line:no-shadowed-variable
        childrenRoutes.forEach(route => {
          if (route.outlet === 'primary') {
            const routeSnapshot = route.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
            if (String(route.snapshot.data.title).indexOf(':id') !== -1 ) {
              route.snapshot.data.title = route.snapshot.data.title.replace(':id', routeSnapshot.params.id);
            }
            if (routeSnapshot.data && routeSnapshot.data.title) {
              this.breadcrumbs.push({
                label: route.snapshot.data as { title: string },
                url:   url.replace('/edit', '')
              });
            }

            currentRoute = route;
          }
        });
      } while (currentRoute);
    });
  }
}
